import moment from "moment";
import { host } from "../conf";
import lg from '../asset/pictures/logo_pdf.png';
import band from '../asset/pictures/header_ban_color.png';

export default function recu(don, watermark, recu_num) {
    var tableau1 = [
        [
            {text: 'Libellé/Destinataire', style:'tableHeader'},
            {text: 'Montant €', style:'tableHeader', alignment: 'center'}
        ]
    ]
    if(don.dime>0)tableau1.push([
        {text: 'Dîme'},
        {text: `${don.dime.toFixed(2)}`, alignment: 'center'}])
    if(don.offrande_globale>0) tableau1.push([
        {text: 'Offrande globale'},
        {text: `${don.offrande_globale.toFixed(2)}`, alignment: 'center'}]
    )
    don.offrande_spe_feam.concat(don.offrande_spe_eglise).map(off=>tableau1.push([
        {text: `${off.libelle}`},
        {text: `${off.montant.toFixed(2)}`, alignment: 'center'}])
    )
    tableau1.push([
        {text: 'Total', style:'tableTotal'},
        {text: (don.dime+don.offrande_globale+don.offrande_spe_feam.concat(don.offrande_spe_eglise).reduce((total, off)=> total+off.montant,0)).toFixed(2), style:'tableTotal', alignment: 'center'},
    ])
  
    var tableau2 = []
    if(don.repartition.cheques.length>0) tableau2.push([
            {text: `Chèques: ${ don.repartition.cheques.length} de ${ don.repartition.cheques.reduce((tt, cq)=>tt+cq.montant,0).toFixed(2)} €`},
        ])
    if(don.repartition?.virement) tableau2.push([
            {text: `Virement: ${ don.repartition.virement?.montant?.toFixed(2)} €`},
        ])
    if(don.repartition?.cb) tableau2.push([
            {text: `Carte Bancaire: ${ don.repartition.cb?.montant?.toFixed(2)} €`},
        ])
    if(don.repartition.especes.length>0) tableau2.push([
            {text: `Billets/Pièces:${ don.repartition.especes.reduce((tt, es)=>tt+' '+es.count+' x '+es.montant.toFixed(2)+'€ ','')}`},
        ])
  
    var dd = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        watermark: watermark && { text: `Remplacé par ${recu_num}`, opacity: 0.3, bold: true, italics: false },
                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [ 30, 20, 120, 15 ],
        header: function(currentPage, pageCount, pageSize) { return {stack: [
            {
                image:band,
                width: 1,
                height:pageSize.height,
                absolutePosition: {x: pageSize.width-100, y: 0}
            },
            {
                image:'logo',
                width: 70,
                height:70,
                absolutePosition: {x: pageSize.width-85, y: 15}
            },
        ]}},
        images: {
            logo: `${host}${lg}`
        },
        content: [
            {columns: [
                {stack: [
                    {margin: [20,0,0,0], columns: [
                        {width:250, text: [
                            {text: `Église Adventiste du 7ème jour\nFédération Martinique\nÉglise ${don.eglise}\n`, fontSize: 13, bold: true, color:'#255760'},
                            
                        ]},
                    {text:'MANGOT VULCIN\n97232 LE LAMENTIN', fontSize: 11, bold: true, color:'#255760'}], columnGap:40},
                    {text: '(Association Loi du 16 Août 1901) - B.P. 50 - 97282 Le Lamentin Cedex 2 ', color: '#255760', style: 'header_footer', margin:[20,0,0,10]},
                    {width:435, canvas: [{type: 'rect',x: 0, y: 0, w: 435, h: 0.5, color: '#255760'}],margin:[0,0,0,10]}
                ]},
            ]},
            {margin: [0,0,10,10], columns: [
                {},
                {text: [
                    {text: `Reçu n°${don.recu_num}\n`, fontSize: 12, bold: true, alignment:'center'},
                    {text: `de ${don.donateur.split(' ').map(w=> w.charAt(0).toUpperCase()+w.slice(1)).join(' ')}\nDate: ${moment.utc(don.date).format('DD/MM/YYYY')}`, alignment:'center'},
                ]}
            ]},
            {table: {
                widths: ['*', 'auto'],
                headerRows: 1,
                body: tableau1
                },
                layout: {defaultBorder: false,
                fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex === node.table.body.length-1) ? '#255760' : (rowIndex % 2 === 0 && rowIndex !== 0) ? '#CCC' : null;
                }
            }},
            {table: {
                widths: ['*'],
                headerRows: 1,
                body: tableau2
                },
                layout: {defaultBorder: false},
                margin:[0, 20, 0, 0]
            }
        ],
        styles:{
            header_footer: {fontSize:8, bold: true},
            header: {fontSize:16, bold: true},
            light_header: {fontSize:14},
            subheader: {fontSize:14, bold: true},
            tableHeader: {bold: true},
            tableTotal: {bold: true, color: '#fff'}
        },
        defaultStyle:{fontSize: 10}        
    }
    return dd
}

export function recu_content(don) {
    var tableau1 = [
        [
            {text: 'Libellé/Destinataire', style:'tableHeader'},
            {text: 'Montant €', style:'tableHeader', alignment: 'center'}
        ]
    ]
    if(don.dime>0)tableau1.push([
        {text: 'Dîme'},
        {text: `${don.dime.toFixed(2)}`, alignment: 'center'}])
    if(don.offrande_globale>0) tableau1.push([
        {text: 'Offrande globale'},
        {text: `${don.offrande_globale.toFixed(2)}`, alignment: 'center'}]
    )
    don.offrande_spe_feam.concat(don.offrande_spe_eglise).map(off=>tableau1.push([
        {text: `${off.libelle}`},
        {text: `${off.montant.toFixed(2)}`, alignment: 'center'}])
    )
    tableau1.push([
        {text: 'Total', style:'tableTotal'},
        {text: (don.dime+don.offrande_globale+don.offrande_spe_feam.concat(don.offrande_spe_eglise).reduce((total, off)=> total+off.montant,0)).toFixed(2), style:'tableTotal', alignment: 'center'},
    ])
  
    var tableau2 = []
    if(don.repartition.cheques.length>0) tableau2.push([
            {text: `Chèques: ${ don.repartition.cheques.length} de ${ don.repartition.cheques.reduce((tt, cq)=>tt+cq.montant,0).toFixed(2)} €`},
        ])
    if(don.repartition?.virement) tableau2.push([
            {text: `Virement: ${ don.repartition.virement?.montant?.toFixed(2)} €`},
        ])
    if(don.repartition?.cb) tableau2.push([
            {text: `Carte Bancaire: ${ don.repartition.cb?.montant?.toFixed(2)} €`},
        ])
    if(don.repartition.especes.length>0) tableau2.push([
            {text: `Billets/Pièces:${ don.repartition.especes.reduce((tt, es)=>tt+' '+es.count+' x '+es.montant.toFixed(2)+'€ ','')}`},
        ])
  
    var dd = [
        {columns: [
            {stack: [
                {margin: [20,0,0,0], columns: [
                    {width:250, text: [
                        {text: `Église Adventiste du 7ème jour\nFédération Martinique\nÉglise ${don.eglise}\n`, fontSize: 13, bold: true, color:'#255760'},
                        
                    ]},
                {text:'MANGOT VULCIN\n97232 LE LAMENTIN', fontSize: 11, bold: true, color:'#255760'}], columnGap:40},
                {text: '(Association Loi du 16 Août 1901) - B.P. 50 - 97282 Le Lamentin Cedex 2 ', color: '#255760', style: 'header_footer', margin:[20,0,0,10]},
                {width:435, canvas: [{type: 'rect',x: 0, y: 0, w: 435, h: 0.5, color: '#255760'}],margin:[0,0,0,10]}
            ]},
        ]},
        {margin: [0,0,10,10], columns: [
            {},
            {text: [
                {text: `Reçu n°${don.recu_num}\n`, fontSize: 12, bold: true, alignment:'center'},
                {text: `de ${don.donateur.split(' ').map(w=> w.charAt(0).toUpperCase()+w.slice(1)).join(' ')}\nDate: ${moment.utc(don.date).format('DD/MM/YYYY')}`, alignment:'center'},
            ]}
        ]},
        {table: {
            widths: ['*', 'auto'],
            headerRows: 1,
            body: tableau1
            },
            layout: {defaultBorder: false,
            fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex === node.table.body.length-1) ? '#255760' : (rowIndex % 2 === 0 && rowIndex !== 0) ? '#CCC' : null;
            }
        }},
        {table: {
            widths: ['*'],
            headerRows: 1,
            body: tableau2
            },
            layout: {defaultBorder: false},
            margin:[0, 20, 0, 0]
        }
    ]
       
    return dd
}

function getEspecesTable(especes, total) {
    const billets = especes.filter(es=> es.montant>=5);
    const pieces = especes.filter(es=> es.montant<5);
    var tableau = [
        [
            {text: 'Billets', style:'tableHeader', alignment: 'center'},
            {text: 'Pièces', style:'tableHeader', alignment: 'center'},
            {text: 'unités', style:'tableHeader', alignment: 'center'},
            {text: 'Montant total €', style:'tableHeader', alignment: 'center'}
        ]
    ]
    billets.map(es=>tableau.push([
        {text: es.montant, alignment: 'center'},
        {},
        {text: es.count, alignment: 'center'},
        {text: (es.count*es.montant).toFixed(2)+' €',  alignment: 'center'}
    ]))
    if(billets.length>0) tableau.push([
        {text: 'Sous-total billets: '+billets.reduce((tt,blt)=>tt+(blt.count*blt.montant),0).toFixed(2)+' €', colSpan:3, bold:true, color:'#255760'},
        {},
        {},
        {}
    ])

    pieces.map(es=>tableau.push([
        {},
        {text: es.montant, alignment: 'center'},
        {text: es.count, alignment: 'center'},
        {text: (es.count*es.montant).toFixed(2)+' €',  alignment: 'center'}
    ]))
    if(pieces.length>0) tableau.push([
        {},
        {text: 'Sous-total pièces: '+pieces.reduce((tt,p)=>tt+(p.count*p.montant),0).toFixed(2)+' €', colSpan:3, bold:true, color:'#255760'},
        {},
        {}
    ])

    tableau.push([
        {text: 'Total', colSpan:3, style:'tableTotal', alignment: 'center'},
        {},
        {},
        {text: total.toFixed(2)+' €', style:'tableTotal', alignment: 'center'}
    ])

    return tableau;
}

function getChequesTable(cheques, total) {
    var tableau = [
        [
            {text: 'N° chèque', style:'tableHeader', alignment: 'center'},
            {text: 'Banque', style:'tableHeader', alignment: 'center'},
            {text: 'Montant €', style:'tableHeader', alignment: 'center'}
        ]
    ]
    cheques.map(cq=>tableau.push([
        {text:cq.num_cheque, alignment: 'center'},
        {text:cq.banque, alignment: 'center'},
        {text: (cq.montant).toFixed(2)+' €', alignment: 'center'}
    ]))
    tableau.push([
        {text: `Total des ${cheques.length} chèques`, colSpan:2, style:'tableTotal', alignment: 'center'},
        {},
        {text: total.toFixed(2)+' €', style:'tableTotal', alignment: 'center'}
    ])
    return tableau;
}

export function bord_versement(fed, versement, eglise,  watermark, vers_num) {
    const totalFedEspeces = versement.fedRepartition.especes.reduce((tt, es)=>tt+es.count*es.montant,0)
    const totalFedCheques = versement.fedRepartition.cheques.reduce((tt, cq)=>tt+cq.montant,0)
    const totalPetiteCaisse = versement.petiteCaisse.reduce((tt, es)=>tt+es.count*es.montant,0)
    const totalBanqueEgliseEspeces = versement.banqueEglise.especes.reduce((tt, es)=>tt+es.count*es.montant,0)
    const totalBanqueEgliseCheques = versement.banqueEglise.cheques.reduce((tt, cq)=>tt+cq.montant,0)
    const fedVirement = versement.fedRepartition.virement?.montant ?? 0;

    const fedPart = totalFedCheques+totalFedEspeces+fedVirement>0 ? [
        {margin: [20,10,0,10], text: `Domiciliation: ${fed.nom}`, fontSize: 13, bold: true},
        totalFedEspeces>0 ? {table: {
            widths: ['*', '*', 'auto', '*'],
            headerRows: 1,
            body: getEspecesTable(versement.fedRepartition.especes, totalFedEspeces)
            },
            layout: {defaultBorder: false,
                fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex === node.table.body.length-1) ? '#255760' : null;
                }
            }
        } : {},
        totalFedCheques>0 ? {table: {
            widths: ['*', '*', '*'],
            headerRows: 1,
            body: getChequesTable(versement.fedRepartition.cheques, totalFedCheques)
            },
            layout: {
                defaultBorder: false,
                fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex === node.table.body.length-1) ? '#255760' : null;
                },
            },
            margin:[0, 20, 0, 0]
        } : {},
        fedVirement>0 ? {text: `Virement: ${versement.fedRepartition.virement?.ref} le ${moment(versement.fedRepartition.virement?.date).format('DD/MM/yyyy')||'---'} de ${fedVirement.toFixed(2)} €`, fontSize: 13, bold:true, margin:[0, 20, 0, 0]} : {},
        {text: `Total du versement ${(totalFedCheques+totalFedEspeces+fedVirement).toFixed(2)} €`, fontSize: 13, bold:true, color:'#D33F49', alignment:'center', margin:[0, 20, 0, 0]},
    ] : []

    const pcPart = totalPetiteCaisse>0 ? [
        {margin: [20,10,0,10], text: `Domiciliation: Petite-Caisse`, fontSize: 13, bold: true},
        {table: {
            widths: ['*', '*', 'auto', '*'],
            headerRows: 1,
            body: getEspecesTable(versement.petiteCaisse, totalPetiteCaisse)
            },
            layout: {defaultBorder: false,
            fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex === node.table.body.length-1) ? '#255760' : null;
            }
        }},
        {text: `Total du versement ${totalPetiteCaisse.toFixed(2)} €`, fontSize: 13, bold:true, color:'#D33F49', alignment:'center', margin:[0, 20, 0, 0]},
    ] : []

    const banquePart = eglise.have_banque && totalBanqueEgliseCheques+totalBanqueEgliseEspeces>0 ? [
        {margin: [20,0,0,10], text: `Domiciliation: Banque Église`, fontSize: 13, bold: true},
        totalBanqueEgliseEspeces>0 ? {table: {
            widths: ['*', '*', 'auto', '*'],
            headerRows: 1,
            body: getEspecesTable(versement.banqueEglise.especes, totalBanqueEgliseEspeces)
            },
            layout: {defaultBorder: false,
            fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex === node.table.body.length-1) ? '#255760' : null;
            }
        }} : {},
        totalBanqueEgliseCheques>0 ? {table: {
            widths: ['*', '*', '*'],
            headerRows: 1,
            body: getChequesTable(versement.banqueEglise.cheques, totalBanqueEgliseCheques)
            },
            layout: {
                defaultBorder: false,
                fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex === node.table.body.length-1) ? '#255760' : null;
                },
            },
            margin:[0, 20, 0, 0],
        } : {},
        {text: `Total du versement ${(totalBanqueEgliseEspeces+totalBanqueEgliseCheques).toFixed(2)} €`, fontSize: 13, bold:true, color:'#D33F49', alignment:'center', margin:[0, 20, 0, 0]},
    ] : []
    
    var dd = {
        pageSize: 'A4',
        watermark: watermark && { text: `Remplacé par ${vers_num}`, opacity: 0.3, bold: true, italics: false },
        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [ 30, 20, 120, 15 ],
        header: function(currentPage, pageCount, pageSize) { return {stack: [
            {
                image:band,
                width: 1,
                height:pageSize.height,
                absolutePosition: {x: pageSize.width-100, y: 0}
            },
            {
                image: 'logo',
                width: 70,
                height:70,
                absolutePosition: {x: pageSize.width-85, y: 15}
            },
        ]}},
        images: {
            logo: `${host}${lg}`
        },
        content: [
            {columns: [
                {stack: [
                    {margin: [20,0,0,10], columns: [
                        {width:250, text: [
                            {text: "Fédération Martinique \nde l'église Adventiste du 7ème jour\n", fontSize: 13, bold: true, color:'#255760'},
                            {text: '(Association Loi du 16 Août 1901)\nB.P. 50 - 97282 Le Lamentin Cedex 2 ', color: '#255760', style: 'header_footer'},
                        ]},
                    {text:'MANGOT VULCIN\n97232 LE LAMENTIN', fontSize: 11, bold: true, color:'#255760'}], columnGap:40},
                    {width:435, canvas: [{type: 'rect',x: 0, y: 0, w: 435, h: 0.5, color: '#255760'}],margin:[0,0,0,10]}
                ]},
            ]},
            {text: `Bordereau de Versement N°${versement.bordereau_num}`, fontSize: 12, bold: true, alignment:'center', margin:[0, 10]},
            {columns: [
                {text: `Église ${eglise?.nom??''}`, fontSize: 12, bold: true, margin:[0,0,20,10]},
                {text: `Date dons: ${moment.utc(versement.dateDons).format('DD/MM/YYYY')}`, fontSize: 12, bold: true, alignment:'right', margin:[20,0,0,0]},
            ]},
            ...fedPart, {text:`\n`}, ...pcPart, {text:`\n`}, ...banquePart
        ],
        styles:{
            header_footer: {fontSize:8, bold: true},
            header: {fontSize:16, bold: true},
            light_header: {fontSize:14},
            subheader: {fontSize:14, bold: true},
            tableHeader: {bold: true},
            tableTotal: {bold: true, color: '#fff'}
        },
        defaultStyle:{ fontSize: 10}  
        
    }

    return dd;
}

export function journalDepense(startDate, endDate, depenses, eglise) {
    const depensesValides = depenses.filter(dp=> !dp.isCanceled && !dp.isCancelLog)
    const totalEspeces = depensesValides.reduce((tt, depense)=>tt+depense.paymode.especes,0)
    const totalCheques = depensesValides.reduce((tt, depense)=>tt+depense.paymode.cheques.reduce((tt, cq)=>tt+cq.montant,0),0)
    const totalCB = depensesValides.reduce((tt, depense)=>tt+(depense.paymode.cb?.montant ?? 0),0)
    const totalPrelevement = depensesValides.reduce((tt, depense)=>tt+(depense.paymode.prelevement?.montant ?? 0),0)
    const totalVirement = depensesValides.reduce((tt, depense)=>tt+(depense.paymode.virement?.montant ?? 0),0)
    const total = totalEspeces + totalCheques + totalCB + totalPrelevement + totalVirement;

    var tableau = [
        [
            {text: 'Date', style:'tableHeader', alignment: 'center'},
            {text: 'Libellé', style:'tableHeader', alignment: 'center'},
            {text: 'Fournisseur', style:'tableHeader', alignment: 'center'},
            {text: 'N° facture', style:'tableHeader', alignment: 'center'},
            {text: 'Mode de paiement', style:'tableHeader', alignment: 'center'},
            {text: 'Compte débité', style:'tableHeader', alignment: 'center'},
            {text: 'Montant €', style:'tableHeader', alignment: 'center'}
        ]
    ]
    depenses.map(dp=>tableau.push([
        {text:moment.utc(dp.date).format('DD/MM/YYYY'), alignment: 'center'},
        {text:dp.libelle+(dp.isCanceled ? ' (Annulée)' : ''), alignment: 'center'},
        {text:dp.fournisseur, alignment: 'center'},
        {text:dp.num_facture, alignment: 'center'},
        {text: (dp.paymode.especes>0 ? ('Espèces: ' + dp.paymode.especes.toFixed(2) + '€\n') : '') +
            (dp.paymode.cheques.length>0 ? (dp.paymode.cheques.length + ' chèque(s): ' + dp.paymode.cheques.reduce((tt, cq)=>tt+cq.montant,0).toFixed(2) + '€\n') : '') +
            (dp.paymode.cb ? ('CB: ' + dp.paymode.cb.montant.toFixed(2) + '€\n') : '') +
            (dp.paymode.virement ? ('Virement: ' + dp.paymode.virement.montant.toFixed(2) + '€\n') : '') +
            (dp.paymode.prelevement ? ('Prélèvement: ' + dp.paymode.prelevement.montant.toFixed(2) + '€') : ''), alignment: 'center'},
        {text: dp.comptes[0]?.libelle, alignment: 'center'},
        {text: (dp.montant).toFixed(2)+' €', alignment: 'center'}
    ]))
    
    var dd = {
        pageSize: 'A4',
        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: 20,
        images: {
            logo: `${host}${lg}`
        },
        content: [
            {columns: [
                {stack: [
                    {margin: [20,15,0,10], columns: [
                        {width:300, text: [
                            {text: `Église ${eglise?.nom??''}`, fontSize: 13, bold: true, color:'#255760'},
                        ]},
                        {text:'le '+moment().format('DD/MM/YYYY'), fontSize: 11, bold: true, color:'#255760'},
                        { image: 'logo', width: 70, height:70, absolutePosition: {x: 505, y: 0} }
                    ], columnGap:40},
                    {width:435, canvas: [{type: 'rect',x: 70, y: 0, w: 300, h: 0.5, color: '#255760'}],margin:[0,0,0,10]},
                ]},
            ]},
            {text: `Journal de dépense`, fontSize: 16, bold: true, alignment:'center', margin:[0, 10]},
            {text: `Période: ${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`, fontSize: 12, bold: true, margin:[20,0,0,0]},
            {table: {
                widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 1,
                body: tableau
                },
                margin:[0, 20, 0, 0]
            },
            {text: `Total des dépenses en espèces: ${totalEspeces.toFixed(2)} €`, fontSize: 10, bold:true, margin:[0, 20, 0, 0]},
            {text: `Total des dépenses par chèques: ${totalCheques.toFixed(2)} €`, fontSize: 10, bold:true, margin:[0, 5, 0, 0]},
            {text: `Total des dépenses CB: ${totalCB.toFixed(2)} €`, fontSize: 10, bold:true, margin:[0, 5, 0, 0]},
            {text: `Total des dépenses Virement: ${totalVirement.toFixed(2)} €`, fontSize: 10, bold:true, margin:[0, 5, 0, 0]},
            {text: `Total des dépenses Prélèvement: ${totalPrelevement.toFixed(2)} €`, fontSize: 10, bold:true, margin:[0, 5, 0, 0]},
            {text: `Total des dépenses: ${total.toFixed(2)} €`, fontSize: 13, bold:true, color:'#D33F49', alignment:'center', margin:[0, 20, 0, 0]},
        ],
        styles:{
            header_footer: {fontSize:8, bold: true},
            header: {fontSize:16, bold: true},
            light_header: {fontSize:14},
            subheader: {fontSize:14, bold: true},
            tableHeader: {bold: true},
            tableTotal: {bold: true, color: '#fff'}
        },
        defaultStyle:{ fontSize: 10}  
        
    }

    return dd;
}